import {
  Home,
  Building2,
  Building,
  Snowflake,
  Flame,
  Wrench,
  Zap,
  HelpCircle,
  Ruler,
  Calendar,
  Key,
  Gauge,
  MapPin,
  Clock,
  LayoutGrid,
} from "lucide-react";

export const steps = [
  // PAGE 0 — LOCATION
  {
    key: "zipCode",
    title: "Enter your ZIP code",
    sheet: "zipCode",
    type: "zip",
    renderOnPage: 0,
  },

  // PAGE 1 — HOME INFORMATION
  {
    key: "homeType",
    title: "What type of home is this?",
    sheet: "homeType",
    largeCards: true,
    icons: [
      Home, // Single-family
      Building2, // Multi-family / condo
      Building, // Townhome / other
    ],
    renderOnPage: 1,
  },
  {
    key: "squareFeet",
    title: "Approximate square footage of the home",
    sheet: "squareFeet",
    icons: [Ruler],
    renderOnPage: 1,
  },
  {
    key: "stories",
    title: "Number of stories",
    sheet: "stories",
    icons: [
      Home, // 1 story
      Building, // 2 stories
      Building2, // 3+ stories
    ],
    renderOnPage: 1,
  },
  {
    key: "yearBuilt",
    title: "Year the home was built",
    sheet: "yearBuilt",
    icons: [Calendar],
    renderOnPage: 1,
  },
  {
    key: "ownership",
    title: "Do you own or rent this home?",
    sheet: "ownership",
    icons: [
      Home, // Own
      Key, // Rent
    ],
    renderOnPage: 1,
  },

  // PAGE 3 — SYSTEM PREFERENCES
  {
    key: "desiredSystemType",
    title: "Type of system you are interested in",
    sheet: "desiredSystemType", // maps to desiredSystemtype in SHEETS
    largeCards: true,
    icons: [
      Snowflake, // Cooling / AC
      Flame, // Heating
      Wrench, // Full system / replacement
    ],
    renderOnPage: 3,
  },
  {
    key: "desiredFuelType",
    title: "Preferred fuel type",
    sheet: "desiredFuelType",
    icons: [
      [Flame, Zap], // Dual fuel
      Zap, // Electric / heat pump
      HelpCircle, // Not sure
    ],
    renderOnPage: 3,
  },

  // PAGE 2 — CURRENT SYSTEM
  {
    key: "currentFuelType",
    title: "Fuel type of your current system",
    sheet: "currentFuelType",
    icons: [
      Flame, // Gas
      Zap, // Electric
      HelpCircle, // Not sure
    ],
    renderOnPage: 2,
  },
  {
    key: "currentACtonnage",
    title: "Current system size (tonnage)",
    sheet: "currentACtonnage",
    icons: [Gauge],
    renderOnPage: 2,
    conditional: {
      dependsOn: "desiredSystemType",
      valueExcludes: "Furnace Only",
    },
  },
  {
    key: "systemlocation",
    title: "Where is your current system located?",
    sheet: "systemlocation",
    icons: [
      MapPin, // Generic location
      Home, // Indoor
      Building2, // Attic / rooftop / other
    ],
    renderOnPage: 2,
  },
  {
    key: "currentSystemAge",
    title: "Age of your current system",
    sheet: "currentSystemAge",
    icons: [Clock],
    renderOnPage: 2,
  },

  // PAGE 3 — MINI SPLIT (CONDITIONAL, inside desired system stage)
  {
    key: "miniSplitRooms",
    title: "How many rooms will need mini-split units?",
    sheet: "miniSplitRooms",
    icons: [LayoutGrid],
    renderOnPage: 3,
    conditional: {
      dependsOn: "desiredSystemType",
      valueIncludes: "Mini",
    },
  },
];
